import React from "react";
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from "configs/AppConfig";

export const publicRoutes = [
  {
    key: "login",
    path: `${AUTH_PREFIX_PATH}/login`,
    component: React.lazy(
      () => import("views/auth-views/authentication/login"),
    ),
  },
  {
    key: "forgot-password",
    path: `${AUTH_PREFIX_PATH}/forgot-password`,
    component: React.lazy(
      () => import("views/auth-views/authentication/forgot-password"),
    ),
  },
];

export const protectedRoutes = [
  {
    key: "dashboard.default",
    path: `${APP_PREFIX_PATH}/dashboard`,
    component: React.lazy(() => import("views/app-views/dashboards/default")),
  },
  {
    key: "dashboard.appointments",
    path: `${APP_PREFIX_PATH}/appointments`,
    component: React.lazy(() => import("views/app-views/appointments")),
  },
  {
    key: "dashboard.categories",
    path: `${APP_PREFIX_PATH}/categories`,
    component: React.lazy(
      () => import("views/app-views/custom/categories/list"),
    ),
  },
  {
    key: "dashboard.inventory",
    path: `${APP_PREFIX_PATH}/inventory`,
    component: React.lazy(
      () => import("views/app-views/custom/inventory/list"),
    ),
  },
  {
    key: "dashboard.discounts",
    path: `${APP_PREFIX_PATH}/discounts`,
    component: React.lazy(() => import("views/app-views/custom/discount/list")),
  },
  {
    key: "dashboard.subscribe-users",
    path: `${APP_PREFIX_PATH}/subscribe-user`,
    component: React.lazy(
      () => import("views/app-views/custom/subscribe-users/list"),
    ),
  },
  {
    key: "dashboard.custom-design",
    path: `${APP_PREFIX_PATH}/custom-design`,
    component: React.lazy(
      () => import("views/app-views/custom/custom-designs/list"),
    ),
  },
  {
    key: "dashboard.discounts.add",
    path: `${APP_PREFIX_PATH}/discounts/:mode`,
    component: React.lazy(
      () => import("views/app-views/custom/discount/operations"),
    ),
  },
  {
    key: "dashboard.discounts.view_edit",
    path: `${APP_PREFIX_PATH}/discounts/:mode/:id`,
    component: React.lazy(
      () => import("views/app-views/custom/discount/operations"),
    ),
  },
  {
    key: "dashboard.products",
    path: `${APP_PREFIX_PATH}/products`,
    component: React.lazy(() => import("views/app-views/custom/products/list")),
  },
  {
    key: "dashboard.products.add",
    path: `${APP_PREFIX_PATH}/products/:mode`,
    component: React.lazy(
      () => import("views/app-views/custom/products/operations"),
    ),
  },
  {
    key: "dashboard.products.view_edit",
    path: `${APP_PREFIX_PATH}/products/:mode/:id`,
    component: React.lazy(
      () => import("views/app-views/custom/products/operations"),
    ),
  },
  {
    key: "dashboard.diamond-shapes",
    path: `${APP_PREFIX_PATH}/diamond-shapes`,
    component: React.lazy(
      () => import("views/app-views/custom/diamond-shapes/index"),
    ),
  },
  {
    key: "dashboard.diamond-list",
    path: `${APP_PREFIX_PATH}/diamond-list`,
    component: React.lazy(
      () => import("views/app-views/custom/diamond-list/index"),
    ),
  },
  {
    key: "dashboard.navigation",
    path: `${APP_PREFIX_PATH}/navigation`,
    component: React.lazy(
      () => import("views/app-views/custom/navigations/list"),
    ),
  },
  {
    key: "dashboard.diamonds",
    path: `${APP_PREFIX_PATH}/diamonds`,
    component: React.lazy(
      () => import("views/app-views/custom/collections/list"),
    ),
  },
  {
    key: "dashboard.variants",
    path: `${APP_PREFIX_PATH}/variants`,
    component: React.lazy(() => import("views/app-views/custom/variants/list")),
  },
  {
    key: "dashboard.materials",
    path: `${APP_PREFIX_PATH}/materials`,
    component: React.lazy(() => import("views/app-views/custom/material/list")),
  },
  {
    key: "dashboard.diamondsize",
    path: `${APP_PREFIX_PATH}/diamondsize`,
    component: React.lazy(() => import("views/app-views/custom/diamondsize")),
  },
  {
    key: "dashboard.collections-items",
    path: `${APP_PREFIX_PATH}/collections-items`,
    component: React.lazy(
      () => import("views/app-views/custom/collections-items/list"),
    ),
  },
  {
    key: "dashboard.sliders",
    path: `${APP_PREFIX_PATH}/sliders`,
    component: React.lazy(() => import("views/app-views/custom/sliders/list")),
  },
  {
    key: "dashboard.instagram-reels",
    path: `${APP_PREFIX_PATH}/instagram-reels`,
    component: React.lazy(
      () => import("views/app-views/custom/instagram-reels/list"),
    ),
  },
  {
    key: "dashboard.customer-review",
    path: `${APP_PREFIX_PATH}/customer-review`,
    component: React.lazy(
      () => import("views/app-views/custom/customer-review-reply"),
    ),
  },
  {
    key: "dashboard.settings",
    path: `${APP_PREFIX_PATH}/settings`,
    component: React.lazy(() => import("views/app-views/custom/settings")),
  },
  {
    key: "apps.ecommerce.orders",
    path: `${APP_PREFIX_PATH}/orders`,
    component: React.lazy(
      () => import("views/app-views/apps/e-commerce/orders"),
    ),
  },
  {
    key: "apps.ecommerce.ordersForm",
    path: `${APP_PREFIX_PATH}/orders/:mode`,
    component: React.lazy(
      () => import("views/app-views/apps/e-commerce/orderForm"),
    ),
  },
  {
    key: "dashboard.contact-us",
    path: `${APP_PREFIX_PATH}/contact-us`,
    component: React.lazy(() => import("views/app-views/contact-us")),
  },
];
